/**
 * Shared UI strings used across more than one feature (buttons, generic labels). Feature-specific
 * copy lives in the sibling `<feature>.ts` files. Keys are dotted and namespaced; `common.*` here.
 *
 * This is the CANONICAL catalog for these keys — `../de/common.ts` must cover every key, which the
 * compiler enforces (`Record<keyof typeof common, string>`). Add a key here first, then translate.
 */
export const common = {
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.close': 'Close',
  'common.create': 'Create',
  'common.confirm': 'Confirm',
  'common.remove': 'Remove',
  'common.edit': 'Edit',
  'common.rename': 'Rename',
  'common.retry': 'Retry',
  'common.loading': 'Loading…',
  'common.search': 'Search…',
} as const;
